// Lightweight form-validation utilities for TikBoost AI.
// Pure functions — no React deps — so they can be unit-tested easily.

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function required(value, label = "This field") {
  if (value === undefined || value === null) return `${label} is required`;
  if (typeof value === "string" && value.trim().length === 0) return `${label} is required`;
  return null;
}

export function email(value, label = "Email") {
  if (!value) return null; // let `required` handle empty
  return EMAIL_REGEX.test(String(value).trim()) ? null : `Enter a valid ${label.toLowerCase()}`;
}

export function minLen(value, n, label = "This field") {
  if (!value) return null;
  return String(value).length >= n ? null : `${label} must be at least ${n} characters`;
}

export function maxLen(value, n, label = "This field") {
  if (!value) return null;
  return String(value).length <= n ? null : `${label} must be at most ${n} characters`;
}

export function strongPassword(value, label = "Password") {
  if (!value) return null;
  if (value.length < 8) return `${label} must be at least 8 characters`;
  if (!/[A-Za-z]/.test(value)) return `${label} needs a letter`;
  if (!/\d/.test(value)) return `${label} needs a number`;
  return null;
}

export function match(value, other, label = "Value", otherLabel = "the confirmation") {
  if (!value) return null;
  return value === other ? null : `${label} doesn't match ${otherLabel}`;
}

// Compose rules — returns the first error encountered.
export function runRules(value, rules = []) {
  for (const rule of rules) {
    const msg = rule(value);
    if (msg) return msg;
  }
  return null;
}

// Validate an object of {field: rules[]}. Returns { errors, valid }.
export function validateForm(values, schema) {
  const errors = {};
  for (const field in schema) {
    const err = runRules(values[field], schema[field]);
    if (err) errors[field] = err;
  }
  return { errors, valid: Object.keys(errors).length === 0 };
}
